import {
  CoinVerticalIcon,
  StarIcon,
  HeartIcon,
  TagIcon,
} from "@phosphor-icons/react";
import { useIntl } from "react-intl";

import { SortButton } from "@/components/SortButton/SortButton";
import { ToggleButtonGroup } from "@/components/ToggleButtonGroup/ToggleButtonGroup";
import {
  HotelsSortOptions,
  type HotelsSortValue,
} from "@/features/hotels/types/types";
import { SortOrder } from "@/types/enums";

type Props = {
  value: HotelsSortValue;
  onChange: (newValue: HotelsSortValue) => void;
};

function HotelsListsSort({ value, onChange }: Props) {
  const intl = useIntl();

  return (
    <ToggleButtonGroup
      orientation="vertical"
      fullWidth
      exclusive
      size="small"
      color="primary"
      aria-label={intl.formatMessage({
        id: "sortOptions",
        defaultMessage: "Sort options",
      })}
    >
      <SortButton
        value={{ field: HotelsSortOptions.RECOMMENDED, order: SortOrder.ASC }}
        isSelected={
          value.field === HotelsSortOptions.RECOMMENDED &&
          value.order === SortOrder.ASC
        }
        onChange={onChange}
      >
        <HeartIcon size={20} className="fill-secondary" weight="bold" />
        {intl.formatMessage({
          id: "hotels.filters.recommendedFirst",
          defaultMessage: "Recommended",
        })}
      </SortButton>

      <SortButton
        value={{ field: HotelsSortOptions.SPECIALDEAL, order: SortOrder.ASC }}
        isSelected={
          value.field === HotelsSortOptions.SPECIALDEAL &&
          value.order === SortOrder.ASC
        }
        onChange={onChange}
      >
        <TagIcon size={20} className="fill-secondary" weight="bold" />
        {intl.formatMessage({
          id: "hotels.filters.specialDealFirst",
          defaultMessage: "Special Deals",
        })}
      </SortButton>

      <SortButton
        value={{ field: HotelsSortOptions.PRICE, order: SortOrder.ASC }}
        isSelected={
          value.field === HotelsSortOptions.PRICE &&
          value.order === SortOrder.ASC
        }
        onChange={onChange}
      >
        <CoinVerticalIcon size={20} className="fill-secondary" weight="bold" />
        {intl.formatMessage({
          id: "hotels.filters.cheapestFirst",
          defaultMessage: "Cheapest first",
        })}
      </SortButton>

      <SortButton
        value={{ field: HotelsSortOptions.RATING, order: SortOrder.DESC }}
        isSelected={
          value.field === HotelsSortOptions.RATING &&
          value.order === SortOrder.DESC
        }
        onChange={onChange}
      >
        <StarIcon size={20} className="fill-secondary" weight="bold" />
        {intl.formatMessage({
          id: "hotels.filters.ratingFirst",
          defaultMessage: "Property Rating And Price",
        })}
      </SortButton>
    </ToggleButtonGroup>
  );
}

export default HotelsListsSort;
